import { PermissionsEnum } from '@/auth/interfaces';

import { useCheckPermissions } from '@/shared';
import { SaveSolicitudEgresoPage } from '../../shared/saveSolicitudesPedidos';
export interface CreateSolicitudesPedidosPageInterface { }

const CreateSolicitudesPedidosPage: React.FC<CreateSolicitudesPedidosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_solicitudegreso)
  return (
    <SaveSolicitudEgresoPage title="Crear Solicitud de Pedido" />
  )
  
};

export default CreateSolicitudesPedidosPage;

